import React from 'react';

export function Tabs({ children, className = '' }) {
  return (
    <div className={className}>
      {children}
    </div>
  );
}

export function TabList({ children, className = '' }) {
  return (
    <div className={`flex border-b border-gray-200 ${className}`}>
      {children}
    </div>
  );
}

export function Tab({ children, active, onClick, className = '' }) {
  return (
    <button
      onClick={onClick}
      className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${
        active
          ? 'border-primary text-primary'
          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
      } ${className}`}
    >
      {children}
    </button>
  );
}

export function TabPanels({ children, className = '' }) {
  return (
    <div className={`mt-4 ${className}`}>
      {children}
    </div>
  );
}

export function TabPanel({ children, active, className = '' }) {
  if (!active) return null;
  
  return (
    <div className={`animate-fade-in ${className}`}>
      {children}
    </div>
  );
}

export default Tabs;
